<script setup lang="ts">
import { computed } from 'vue';

import { updateQueryParam, validateBuilderUrl } from '@/utils/cms';

const { src } = defineProps<{
  alt: string;
  highPriority?: boolean;
  imgClasses?: string;
  sizes?: string;
  src: string;
}>();

const srcSizes = [100, 200, 400];

const srcset = computed(() => {
  if (!validateBuilderUrl(src)) return src;

  let normalizedSrc = src;
  const widthInSrc = Number(src.split('?width=')[1]);
  if (!Number.isNaN(widthInSrc)) {
    normalizedSrc = `${normalizedSrc} ${widthInSrc}w`;
  }

  return srcSizes
    .filter((size) => size !== widthInSrc)
    .map((size) => `${updateQueryParam(src, 'width', size)} ${size}w`)
    .concat([normalizedSrc])
    .join(', ');
});

const webpSrcSet = computed(() => {
  if (!validateBuilderUrl(src)) return undefined;

  return srcset.value
    .split(',')
    .filter((entry) => entry.includes('width='))
    .map((entry) => {
      const [url, descriptor] = entry.trim().split(/\s+/);
      const webpUrl = updateQueryParam(url, 'format', 'webp');
      return descriptor ? `${webpUrl} ${descriptor}` : webpUrl;
    })
    .join(', ');
});
</script>

<template>
  <picture>
    <source v-if="webpSrcSet" :srcset="webpSrcSet" type="image/webp" />
    <img
      :alt
      :class="imgClasses"
      :loading="highPriority ? 'eager' : 'lazy'"
      :src
      :srcset="srcset"
      :sizes
    />
  </picture>
</template>
